import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { requestNotificationPermission } from "./constants/firebase";

// Browser fallback for the /sign-in app link.
// Runs before HashRouter mounts.
if (
  window.location.pathname === "/sign-in" ||
  window.location.pathname === "/sign-in/"
) {
  const query = window.location.search;

  window.history.replaceState(
    window.history.state,
    "",
    `/#/sign-in${query}`
  );
}

const isWebViewIOS = () => {
  const ua = navigator.userAgent || "";

  return (
    /iPhone|iPad|iPod/.test(ua) &&
    Boolean(window.ReactNativeWebView)
  );
};

// Register notifications when supported, excluding iOS WebView.
if ("serviceWorker" in navigator && !isWebViewIOS()) {
  window.addEventListener("load", async () => {
    try {
      await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );

      await requestNotificationPermission();
    } catch (err) {
      console.error(
        "Service worker registration or notification setup failed:",
        err
      );
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();